/**
 * Created by sunjinyu on 2018/11/12.
 */
export default {
  orderDetails: null
}



// WEBPACK FOOTER //
// ./src/store/state.js